import { render, staticRenderFns } from "./ServiceTypeSelector.vue?vue&type=template&id=7845dbee&scoped=true&class=justify-center"
import script from "./ServiceTypeSelector.vue?vue&type=script&lang=js"
export * from "./ServiceTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./ServiceTypeSelector.vue?vue&type=style&index=0&id=7845dbee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7845dbee",
  null
  
)

export default component.exports